export default "__VITE_ASSET__Hh2Jyy0ADZm282Yl$Ak61Q__"